import { render, staticRenderFns } from "./gps-field.vue?vue&type=template&id=19d967a9&scoped=true&"
import script from "./gps-field.vue?vue&type=script&lang=js&"
export * from "./gps-field.vue?vue&type=script&lang=js&"
import style0 from "./gps-field.vue?vue&type=style&index=0&id=19d967a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d967a9",
  null
  
)

export default component.exports